import { z } from 'zod';

import { Box, BoxProps, Flex, Heading, Text } from '@chakra-ui/react';

import { FAQSection } from '~/components/faq-section';
import { Glyph } from '~/components/glyph';
import { Link } from '~/components/link';

function HelpCenterInfo(props: BoxProps) {
  return (
    <Box {...props}>
      <Flex alignItems='center' as='aside' gap='12px'>
        <Glyph height={32} name='chat-bubbles-text-two' width={32} />
        <Text>
          Have additional questions? <Link href='https://support.udacity.com'>Visit Our Help Center</Link>
        </Text>
      </Flex>
    </Box>
  );
}
const faqSchema = z.object({
  question: z.string(),
  answer: z.string(),
});
export const purchaseFaqSchema = z.object({
  title: z.string(),
  faq: z.array(faqSchema),
});

export type PurchaseFaqProps = z.infer<typeof purchaseFaqSchema>;

export function PurchaseFaqSection({ title, faq }: PurchaseFaqProps) {
  return (
    <FAQSection
      faq={faq.map((faq, idx) => ({ ...faq, _id: String(idx) }))}
      footerSlot={<HelpCenterInfo />}
      titleSlot={
        <Heading as='h2' marginBottom='24px' size='h2'>
          {title}
        </Heading>
      }
    />
  );
}
